/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Api documentation
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateHistoryGroupReq,
  HistoryGroupItemResp,
  ListHistoryGroupsParams,
  MoveHistoryItemReq,
  UpdateHistoryGroupReq,
} from "./history-group-api.schemas.js";

import { apiRequest } from "../context/api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const listHistoryGroups = (
  params?: ListHistoryGroupsParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<HistoryGroupItemResp[]>(
    { url: `/intl/history-groups`, method: "GET", params, signal },
    options,
  );
};

export const getListHistoryGroupsQueryKey = (
  params?: ListHistoryGroupsParams,
) => {
  return [`/intl/history-groups`, ...(params ? [params] : [])] as const;
};

export const getListHistoryGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof listHistoryGroups>>,
  TError = unknown,
>(
  params?: ListHistoryGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listHistoryGroups>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListHistoryGroupsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listHistoryGroups>>
  > = ({ signal }) => listHistoryGroups(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listHistoryGroups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListHistoryGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHistoryGroups>>
>;
export type ListHistoryGroupsQueryError = unknown;

export function useListHistoryGroups<
  TData = Awaited<ReturnType<typeof listHistoryGroups>>,
  TError = unknown,
>(
  params: undefined | ListHistoryGroupsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listHistoryGroups>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHistoryGroups>>,
          TError,
          Awaited<ReturnType<typeof listHistoryGroups>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListHistoryGroups<
  TData = Awaited<ReturnType<typeof listHistoryGroups>>,
  TError = unknown,
>(
  params?: ListHistoryGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listHistoryGroups>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHistoryGroups>>,
          TError,
          Awaited<ReturnType<typeof listHistoryGroups>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListHistoryGroups<
  TData = Awaited<ReturnType<typeof listHistoryGroups>>,
  TError = unknown,
>(
  params?: ListHistoryGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listHistoryGroups>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListHistoryGroups<
  TData = Awaited<ReturnType<typeof listHistoryGroups>>,
  TError = unknown,
>(
  params?: ListHistoryGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listHistoryGroups>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListHistoryGroupsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const createHistoryGroup = (
  createHistoryGroupReq?: CreateHistoryGroupReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<HistoryGroupItemResp>(
    {
      url: `/intl/history-groups`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createHistoryGroupReq,
      signal,
    },
    options,
  );
};

export const getCreateHistoryGroupMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createHistoryGroup>>,
    TError,
    { data?: CreateHistoryGroupReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createHistoryGroup>>,
  TError,
  { data?: CreateHistoryGroupReq },
  TContext
> => {
  const mutationKey = ["createHistoryGroup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createHistoryGroup>>,
    { data?: CreateHistoryGroupReq }
  > = (props) => {
    const { data } = props ?? {};

    return createHistoryGroup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateHistoryGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof createHistoryGroup>>
>;
export type CreateHistoryGroupMutationBody = CreateHistoryGroupReq | undefined;
export type CreateHistoryGroupMutationError = unknown;

export const useCreateHistoryGroup = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createHistoryGroup>>,
      TError,
      { data?: CreateHistoryGroupReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createHistoryGroup>>,
  TError,
  { data?: CreateHistoryGroupReq },
  TContext
> => {
  return useMutation(
    getCreateHistoryGroupMutationOptions(options),
    queryClient,
  );
};
export const updateHistoryGroup = (
  id: string,
  updateHistoryGroupReq?: UpdateHistoryGroupReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<HistoryGroupItemResp>(
    {
      url: `/intl/history-groups/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateHistoryGroupReq,
      signal,
    },
    options,
  );
};

export const getUpdateHistoryGroupMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHistoryGroup>>,
    TError,
    { id: string; data?: UpdateHistoryGroupReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateHistoryGroup>>,
  TError,
  { id: string; data?: UpdateHistoryGroupReq },
  TContext
> => {
  const mutationKey = ["updateHistoryGroup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateHistoryGroup>>,
    { id: string; data?: UpdateHistoryGroupReq }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateHistoryGroup(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateHistoryGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateHistoryGroup>>
>;
export type UpdateHistoryGroupMutationBody = UpdateHistoryGroupReq | undefined;
export type UpdateHistoryGroupMutationError = unknown;

export const useUpdateHistoryGroup = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateHistoryGroup>>,
      TError,
      { id: string; data?: UpdateHistoryGroupReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateHistoryGroup>>,
  TError,
  { id: string; data?: UpdateHistoryGroupReq },
  TContext
> => {
  return useMutation(
    getUpdateHistoryGroupMutationOptions(options),
    queryClient,
  );
};
export const deleteHistoryGroup = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/intl/history-groups/${id}`, method: "DELETE", signal },
    options,
  );
};

export const getDeleteHistoryGroupMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteHistoryGroup>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteHistoryGroup>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteHistoryGroup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteHistoryGroup>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteHistoryGroup(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteHistoryGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteHistoryGroup>>
>;

export type DeleteHistoryGroupMutationError = unknown;

export const useDeleteHistoryGroup = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteHistoryGroup>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteHistoryGroup>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(
    getDeleteHistoryGroupMutationOptions(options),
    queryClient,
  );
};
export const moveHistoryItem = (
  moveHistoryItemReq?: MoveHistoryItemReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/intl/history-groups/items`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: moveHistoryItemReq,
      signal,
    },
    options,
  );
};

export const getMoveHistoryItemMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveHistoryItem>>,
    TError,
    { data?: MoveHistoryItemReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof moveHistoryItem>>,
  TError,
  { data?: MoveHistoryItemReq },
  TContext
> => {
  const mutationKey = ["moveHistoryItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof moveHistoryItem>>,
    { data?: MoveHistoryItemReq }
  > = (props) => {
    const { data } = props ?? {};

    return moveHistoryItem(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MoveHistoryItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof moveHistoryItem>>
>;
export type MoveHistoryItemMutationBody = MoveHistoryItemReq | undefined;
export type MoveHistoryItemMutationError = unknown;

export const useMoveHistoryItem = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof moveHistoryItem>>,
      TError,
      { data?: MoveHistoryItemReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof moveHistoryItem>>,
  TError,
  { data?: MoveHistoryItemReq },
  TContext
> => {
  return useMutation(getMoveHistoryItemMutationOptions(options), queryClient);
};
